import React, {  } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from "@material-ui/core/Grid/Grid";

import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Typography from "@material-ui/core/Typography";

import ProducaoNoTempoChart from "./ProducaoNoTempoChart";
import ProducaoDiaSemanaChart from "./ProducaoDiaSemanaChart";


const useStyles = makeStyles(theme => ({

    mainGrid: {
      margin: 0,
      display: 'flex',
        height: '100mm',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      alignItems: 'stretch',
      alignContent: 'stretch',
      border: 1,
      borderStyle: 'solid',
      borderColor: 'black',
      borderRadius: '5px'
    },
    grid1Linha: {
        width: '100%',

        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        alignItems: 'stretch',
        alignContent: 'stretch',
        border: 1,
        // borderStyle: 'solid',
        borderColor: 'black',
        borderRadius: '5px'
    },
    gridColuna: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        alignItems: 'stretch',
        alignContent: 'stretch',
        border: 1,
        // borderStyle: 'solid',
        borderColor: 'black',
        borderRadius: '5px'
    },
    marginAuto:{
      flexGrow: 1,
      flexShrink: 1,
      margin: '8px',
      border: '3px',
      borderColor: 'yellow',

  }
}));

const renderLoadingScreen = () => {
    const { classes } = this.props;
    return (
        <React.Fragment>
            {this.renderSearchComponent()}
            <div align="center">
                <CircularProgress className={classes.progress} />
            </div>
        </React.Fragment>
    )
}

export default function DistribuicaoNoTempo(prop) {
  const { raspaReportData} = prop;

  const classes = useStyles();


    return (
    <Grid container xs={12} className={classes.mainGrid}>
        <Grid item id={'titulo kpi'} className={classes.marginAuto} sm={12} md={12}>
            <Typography>DISTRIBUICAO NO TEMPO</Typography>
        </Grid>
        <Grid item id={'titulo kpi'} className={classes.marginAuto}  style={{ width: '100%',  alignItems:'center'}}>
            <ProducaoNoTempoChart
                data={raspaReportData.periodo.totaisPorData}
                titulo={"# RASPAGENS POR DIA DO MES"}
                height={150} width={690}
                axisX={true} maxBarSize={20}
            />
        </Grid>

        <Grid container item id={'RaspaKpi-1aLinha'} className={classes.grid1Linha} >

            <Grid item className={classes.gridColuna} style={{ width: '50%', alignItems:'center'}}>
                <ProducaoNoTempoChart
                    data={raspaReportData.periodo.totaisPorHora}
                    titulo={"# RASPAGENS POR HORA DO DIA"}
                    dataKeyX={"hora"}
                    height={150} width={330} legenda={false}
                />
            </Grid>
            <Grid item className={classes.gridColuna} style={{ width: '50%', alignItems:'center'}}>
                <ProducaoDiaSemanaChart
                    data={raspaReportData.periodo.totaisPorDiaDaSemana}
                    titulo={"# RASPAGENS POR DIA DA SEMANA"}
                    dataKeyX={"dow"}
                    height={150} width={330} legenda={false}
                />
            </Grid>



        </Grid>
    </Grid>
  )
}
;
